import { Observable, of } from 'rxjs';
import { LoadAllFacade } from '../models';

export function loadStoreState(facade: LoadAllFacade, params?: unknown): Observable<boolean> {
  facade.loadAll(params);
  return of(true);
}
